import React from "react"

import ErrorScreen from "../screens/Generic/ErrorScreen/ErrorScreen"
import { enhanceStaticProps } from "../utils/getStaticProps"
import { loadTranslations } from "../utils/i18n/server"

const ErrorPage = () => {
  return <ErrorScreen statusCode={500} />
}

export const getStaticProps = enhanceStaticProps(async ({ localeData: { language } }) => {
  const translations = await loadTranslations({ language })

  return {
    props: {
      ...translations,
    },
  }
})

export default ErrorPage
